var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnergy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0895 19.2777H12.5945C10.0297 19.2777 8.74738 19.2777 8.21032 18.4373C7.67327 17.5968 8.21202 16.4331 9.28953 14.1057L14.2632 3.36249C14.9446 1.89069 15.2853 1.15479 15.6426 1.23349C16 1.3122 16 2.12313 16 3.74501V11.8117C16 12.2409 16 12.4555 16.1333 12.5889C16.2666 12.7222 16.4812 12.7222 16.9105 12.7222H19.4054C21.9702 12.7222 23.2525 12.7222 23.7896 13.5627C24.3267 14.4031 23.7879 15.5668 22.7104 17.8942L17.7367 28.6374C17.0553 30.1092 16.7146 30.8451 16.3573 30.7664C16 30.6877 16 29.8768 16 28.2549V20.1882C16 19.759 16 19.5444 15.8666 19.4111C15.7333 19.2777 15.5187 19.2777 15.0895 19.2777Z",
    fill: "#5F3FC0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.a556010c0edcc710a498b09242235b3b.svg";
export { ForwardRef as ReactComponent };